export default __webpack_public_path__ + "static/media/jibon-large.00516652.png";